import Vue from 'vue'
import es6Promise from 'es6-promise'

import App from './App.vue'
import router from './router'
import './plugins/element.js'
import api from './services/api'
import './utils/extends'
import store from './store'
import config from './config'

Vue.config.productionTip = false

window.Promise = es6Promise.Promise

Vue.prototype.$config = config

api.checkLogin().then(() => {
  localStorage.user = 'wisdom'
}).finally(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
